import { useMemo } from 'react';
import classes from '../ReportResult/OldReportResult.module.css';
import RealPlayRecordDataHelper from 'features/realplays/RealPlayRecordData.helper';
import RealPlayQualifiedDataHelper from 'features/realplays/RealPlayQualifiedData.helper';
import ScenarioContext from '../ReportResult/ScenarioContext';
import RoleplayRecording from '../ReportResult/RoleplayRecording';
import Strengths from '../ReportResult/Strengths';
import Improvements from '../ReportResult/Improvements';

const OldNewRealPlayLeftSection = ({ isLoadingResponse, playerRef, handleSeek = () => null }) => {
  const {
    scenarios,
    customer_context,
    selectedScenario,
    title,
    videoURL,
    persona_name: prospectName,
  } = RealPlayRecordDataHelper();

  const { summary } = RealPlayQualifiedDataHelper();

  const customer_role = useMemo(() => customer_context?.role, [customer_context?.role]);
  const customer_industry = useMemo(() => customer_context?.industry, [customer_context?.industry]);
  const customer_situation = useMemo(
    () => customer_context?.situation,
    [customer_context?.situation]
  );

  return (
    <div className={classes.left}>
      {/* Scenario Context */}
      <ScenarioContext
        prospectName={prospectName}
        customer_role={customer_role}
        customer_industry={customer_industry}
        customer_situation={customer_situation}
        selectedScenario={selectedScenario}
        scenarios={scenarios}
        title={title}
      />
      {/* Roleplay Recording */}
      <RoleplayRecording videoURL={videoURL} playerRef={playerRef} />
      {/* Strengths */}
      <Strengths summary={summary} isLoadingResponse={isLoadingResponse} handleSeek={handleSeek} />
      {/* Practice & Improve */}
      <Improvements summary={summary} isLoadingResponse={isLoadingResponse} />
    </div>
  );
};

export default OldNewRealPlayLeftSection;